import {Hotel} from 'modules/sapiSearch/slice'
import {toggle} from 'opticks'

import {useGetHotelQuery} from '@daedalus/core/src/sapi/services/searchApi'
import {ImageCategory} from '@findhotel/sapi'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src'

// Category-based selection logic
export const CATEGORY_ORDER: {
  id: ImageCategory['id']
  max: number
}[] = [
  {id: '91024', max: 2}, // Exterior
  {id: '21001', max: 2}, // Room
  {id: '30000', max: 1}, // Pool
  {id: '22000', max: 1}, // Common area
  {id: '81000', max: 1} // Dining
]
function sortMosaicImages(
  images: ContentHotel['images'] = []
): ContentHotel['images'] {
  const hero = images[0]
  // For each category, get up to max images for that category
  const categorized = [
    hero,
    ...CATEGORY_ORDER.map(({id, max}) =>
      images
        .filter(img => img.category.some(cat => cat.id === id))
        .slice(0, max)
    )
  ]
  const rest = images.filter(img => !categorized.flat().includes(img))
  // Flatten all arrays to get the sorted images
  return [...categorized, rest].flat()
}

export const useGetHotelDetails = (hotelId: string): Hotel | ContentHotel => {
  // get the hotel's details from API instead of hotelEntities
  const {data} = useGetHotelQuery(
    {
      hotelId,
      transformResponse: hotel => {
        const sortedImages = toggle(
          '77b06d58-categorize-hotel-images-on-ap',
          hotel.images,
          sortMosaicImages(hotel.images)
        )
        return {...hotel, images: sortedImages}
      }
    },
    {
      skip: !hotelId
    }
  )

  return data
}
